import { createUseStyles } from 'react-jss';

import { mixins } from 'resources/styles/mixins';

const useStyles = createUseStyles(() => ({
  eventPeople: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',

    '& .userTooltipArea': {
      position: 'relative',
      scrollSnapAlign: 'start',

      '&.isDj': {
        cursor: 'pointer',
      },
    },

    '& .name': {
      ...mixins.longText,
      textAlign: 'center',
      width: '100%',
      color: 'var(--text-secondary)',
      position: 'absolute',
      transform: 'translateY(100%)',
      bottom: '-4px',
      lineHeight: '14px',
      fontSize: '12px',

      '@media screen and (min-width: 1441px)': {
        bottom: '-6px',
        lineHeight: '24px',
        fontSize: '15px',
      },
    },

    '& .roleBadge': {
      padding: '2px',
      position: 'absolute',
      bottom: 0,
      right: 0,

      '&:after': {
        right: '0.2px',
        bottom: '0',
        content: '""',
        position: 'absolute',
        width: '18px',
        height: '18px',
        backgroundColor: 'var(--background-paper)',
        borderRadius: '50%',
        zIndex: 1,

        '@media screen and (min-width: 1441px)': {
          width: '20px',
          height: '20px',
        },
      },

      '&:before': {
        zIndex: 2,
        position: 'relative',
      },

      '&.dj': {
        color: 'var(--success-main)',
      },

      '&.host': {
        color: 'var(--primary-main)',
      },

      '&.guest': {
        color: 'var(--text-secondary)',
      },
    },

    '& .viboImage': {
      borderRadius: '50%',
      width: '44px',
      height: '44px',

      '@media screen and (min-width: 1441px)': {
        width: '56px',
        height: '56px',
      },
    },

    '@media screen and (min-width: 1441px)': {
      gap: '8px',
    },
  },

  roleTooltipOverlay: {
    display: 'flex',
    gap: '2px',

    '& .role': {
      textTransform: 'capitalize',
    },
  },
}));

export default useStyles;
